export enum Events {
    Location = "location",
    RunQuiz = "run_quiz",
    QuizCreated = "quiz_created",
    JoinQuiz = "join_quiz",
    QuizJoined = "quiz_joined",
    PlayerJoined = "player_joined",
    StartQuiz = "start_quiz",
    QuizStarted = "quiz_started",
    SubmitAnswer = "submit_answer",
    AnswerSubmitted = "answer_submitted",
    NextQuestion = "next_question",
    NewQuestion = "new_question",
    QuizCompleted = "quiz_completed"

}